import http from '@/api/http'
import { createApiError, parseApiResponse } from '@/api/parseApiResponse'

async function authRequest(request) {
  try {
    const response = await request()
    return parseApiResponse(response)
  } catch (error) {
    if (error?.response) {
      throw createApiError(error.response)
    }
    throw error
  }
}

export async function loginWithTelegramApi({ initData, refCode }) {
  return authRequest(() =>
    http.post('/auth/telegram', {
      initData,
      refCode: refCode ?? undefined,
    }),
  )
}

export async function loginWithPasswordApi({ email, password }) {
  return authRequest(() => http.post('/auth/login', { email, password }))
}

export async function registerApi({
  email,
  password,
  first_name,
  last_name,
  phone_number,
  ref,
  utm,
}) {
  return authRequest(() =>
    http.post('/auth/register', {
      email,
      password,
      first_name,
      last_name,
      phone_number,
      ...(ref ? { ref } : {}),
      ...(utm ? { utm } : {}),
    }),
  )
}

export async function registerCourierApi({ email, password, first_name, last_name, phone_number }) {
  return authRequest(() =>
    http.post('/auth/register/courier', {
      email,
      password,
      first_name,
      last_name,
      phone_number,
    }),
  )
}

export async function registerRestaurantApi({ email, password, title }) {
  return authRequest(() =>
    http.post('/auth/register/restaurant', {
      email,
      password,
      title,
    }),
  )
}

export async function logoutApi() {
  return authRequest(() => http.post('/auth/logout'))
}

export async function fetchSessionApi() {
  return authRequest(() => http.get('/auth/is-authenticated'))
}

export async function changePasswordApi({ currentPassword, newPassword }) {
  return authRequest(() =>
    http.post('/personal/password', {
      current_password: currentPassword,
      new_password: newPassword,
    }),
  )
}
